import { useCallback, useEffect, useState } from 'react';
import { type DirectLine, ConnectionStatus } from 'botframework-directlinejs';
import { type ILogger } from '@bingads-webui-react/copilot-utils';
import { fakeLogger } from './utils';

interface IUseCopilotDegrade {
  token: string | undefined;
  directLine: DirectLine | null,
  isDegradedModeEnabled: boolean;
  logger?: ILogger,
}

export const useCopilotDegrade = ({
  token,
  directLine,
  isDegradedModeEnabled,
  logger = fakeLogger,
}: IUseCopilotDegrade) => {
  const [isDegraded, setIsDegraded] = useState(false);

  // token not available
  useEffect(() => {
    if (isDegradedModeEnabled && !token) {
      logger.error(`[Copilot - Degrade] Triggered due to token fetch failed, token length: ${token?.length}`);
      setIsDegraded(true);
    }
  }, [token, isDegradedModeEnabled, logger]);

  // direct line connection failed
  useEffect(() => {
    if (isDegradedModeEnabled && directLine) {
      directLine.connectionStatus$.subscribe((status) => {
        if (status === ConnectionStatus.FailedToConnect) {
          logger.error(`[Copilot - Degrade] Triggered due to DirectLine connection status: ${ConnectionStatus[status]}`);
          setIsDegraded(true);
        }
      });
    }
  }, [directLine, isDegradedModeEnabled, logger]);

  const enableDegradeOnError = useCallback((message: string) => {
    if (isDegradedModeEnabled) {
      logger.error(`[Copilot - Degrade] Triggered due to error: ${message}`);
      setIsDegraded(true);
    }
  }, [isDegradedModeEnabled, logger]);

  const resetDegradeMode = useCallback(() => {
    setIsDegraded(false);
  }, []);

  return {
    isCopilotDegraded: isDegraded,
    enableDegradeOnError,
    resetDegradeMode,
  };
};
